import React from 'react';
import {
    Box,
    Paper,
    List,
    ListItemButton,
    ListItemText,
    useTheme,
    useMediaQuery,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    type SelectChangeEvent
} from '@mui/material';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { USER_MANUAL_NAV_ITEMS } from '../../config/userManualNav';

export default function UserManualLayout() {
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const isWide = useMediaQuery(theme.breakpoints.up('md'));

    if (location.pathname === '/user-manual') {
        return <Navigate to="/user-manual/overview" replace />;
    }

    const handleSelectSection = (event: SelectChangeEvent<string>) => {
        navigate(event.target.value);
    };

    return (
        <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0, pb: 3 }}>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 2,
                    border: 1,
                    borderColor: 'divider',
                    overflow: 'hidden',
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'stretch', md: 'stretch' },
                    minHeight: { md: 360 }
                }}
            >
                {isWide ? (
                    <Box
                        component="nav"
                        aria-label="User manual sections"
                        sx={{
                            width: 220,
                            flexShrink: 0,
                            borderRight: 1,
                            borderColor: 'divider',
                            bgcolor: theme.palette.action.hover,
                            py: 1
                        }}
                    >
                        <List dense disablePadding>
                            {USER_MANUAL_NAV_ITEMS.map((section) => (
                                <ListItemButton
                                    key={section.id}
                                    selected={location.pathname === section.path}
                                    onClick={() => navigate(section.path)}
                                    sx={{ px: 2, py: 1 }}
                                >
                                    <ListItemText
                                        primary={section.label}
                                        primaryTypographyProps={{
                                            variant: 'body2',
                                            fontWeight: location.pathname === section.path ? 600 : 400
                                        }}
                                    />
                                </ListItemButton>
                            ))}
                        </List>
                    </Box>
                ) : (
                    <FormControl fullWidth size="small" sx={{ p: 2, pb: 0 }}>
                        <InputLabel id="user-manual-section-label">Section</InputLabel>
                        <Select
                            labelId="user-manual-section-label"
                            id="user-manual-section"
                            label="Section"
                            value={USER_MANUAL_NAV_ITEMS.some((s) => s.path === location.pathname) ? location.pathname : ''}
                            onChange={handleSelectSection}
                        >
                            {USER_MANUAL_NAV_ITEMS.map((section) => (
                                <MenuItem key={section.id} value={section.path}>
                                    {section.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                <Box sx={{ flex: 1, minWidth: 0, p: { xs: 2, sm: 3 } }}>
                    <Outlet />
                </Box>
            </Paper>
        </Box>
    );
}
